import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import {PageGenericPrismic} from '../components/page-generic-prismic';

export interface CookiePolicyPageProps {}

@inject(deps) @observer
export class CookiePolicyPage extends Component<CookiePolicyPageProps> {
  render() {
    return (
      <PageGenericPrismic
        model={this.props.model.page.cookiePolicy}
      />
    )
  }
}